import axios from "axios";
import * as Sentry from "@sentry/react";
import { authService } from "../services/AuthService";
import { intercomService } from "../services/IntercomService";
import { withAccessTokenHeaders } from "../utilities/auth";
import { HTTP_ENDPOINTS } from "../consts/api";
import { history } from "../history";
import { ROUTES } from "../consts/routes";
import { LOGOUT_REASONS } from "../consts/auth";
import { LOCAL_STORAGE_KEYS } from "../consts/localStorage";

const logoutInstance = (() => {
  const instance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
  });

  instance.interceptors.request.use(withAccessTokenHeaders);

  return instance;
})();

export const getLogout =
  (http) =>
  async ({ reason } = {}) => {
    const payload = {
      idle_last_active:
        localStorage.getItem(LOCAL_STORAGE_KEYS.idle_lastActive) || null,
      action_time: Date.now(),
    };

    var initiate = () => {
      Sentry.captureMessage("helpers auth getLogout initiate", {
        extra: {
          reason,
        },
      });
      authService.logout();
      intercomService.shutdown();

      if (reason === LOGOUT_REASONS.sessionExpire) {
        history.replace(`${ROUTES.login()}?sessionExpired=true`);
      } else {
        history.replace(ROUTES.login());
      }
    };

    return http
      .get(HTTP_ENDPOINTS.logout(), { params: payload })
      .finally(initiate);
  };

export const logout = getLogout(logoutInstance);
